import useSWR from "swr";
import { uploadMultiPartFileApi } from "../api";

const useFetchSampleFiles = () => {
  const { data, error, isLoading } = useSWR(
    `user/sample-files`,
    () => uploadMultiPartFileApi.fetchSampleFilesList(),
    {
      revalidateOnFocus: false
    }
  );

  return {
    data: data?.data?.responseData?.sampleFiles,
    isLoading,
    isError: error
  };
};

export default useFetchSampleFiles;
